import * as React from 'react';
import { Fragment, useEffect } from 'react';

import useRouter from 'js/lib/useRouter';

type Props = {
  ignorePathSegment?: string;
  when: boolean;
  message: string;
};

export const showDialog = (event: Event) => {
  event.preventDefault();
  // we need to assing to returnValue or this won't work on chrome
  // eslint-disable-next-line no-param-reassign
  event.returnValue = true;
};

/**
 *  Blocks both react-router navigations and hard browser navigations behnd a confirmation prompt
 */
const NavigationPrompt = ({ when, message, ignorePathSegment }: Props) => {
  const router = useRouter();
  const currentRoute = router.routes[router.routes.length - 1];

  useEffect(() => {
    // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
    const remove = router.setRouteLeaveHook(currentRoute, (nextRoute) => {
      if (nextRoute && ignorePathSegment && nextRoute.pathname.includes(`/${ignorePathSegment}/`)) {
        return true;
      }

      // eslint-disable-next-line no-alert
      return when ? confirm(message) : true;
    });
    return remove;
  }, [when, currentRoute, message, router, ignorePathSegment]);

  useEffect(() => {
    if (when) {
      window.addEventListener('beforeunload', showDialog);
    } else {
      window.removeEventListener('beforeunload', showDialog);
    }

    return () => {
      window.removeEventListener('beforeunload', showDialog);
    };
  }, [when]);
  return <Fragment />;
};

export default NavigationPrompt;
